import { useState, useEffect } from 'react';
import { ThemeProvider } from 'styled-components';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { motion } from 'motion/react'
import { AppProps } from 'next/app';
import { ReactNotifications } from 'react-notifications-component';
import '../client/styles/fonts.css';

import 'react-image-gallery/styles/css/image-gallery.css';
import 'react-notifications-component/dist/theme.css';

import GlobalStyles from 'styles/GlobalStyles';
import { Layout } from 'components';
import { LoadingDots, theme } from 'components/core';

import Script from 'next/script';
import getConfig from 'next/config';
import { Styled } from 'components/Layout';
import { Router } from 'next/router';

function GlobalStore(props: AppProps) {
  const { Component, pageProps } = props;
  const [isRouteLoading, setRouteLoading] = useState(false);

  useEffect(() => {
    const start = () => {
      setRouteLoading(true);
    };
    const end = () => {
      setRouteLoading(false);
    };
    Router.events.on('routeChangeStart', start);
    Router.events.on('routeChangeComplete', end);
    Router.events.on('routeChangeError', end);
    return () => {
      Router.events.off('routeChangeStart', start);
      Router.events.off('routeChangeComplete', end);
      Router.events.off('routeChangeError', end);
    };
  }, []);
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            retry: 2,
          },
        },
      })
  );

  const { publicRuntimeConfig } = getConfig();

  return (
    <>
      <Script id="google-tag-manager" strategy="afterInteractive">
        {`
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${publicRuntimeConfig.GTM_TRACKING_ID}');
        `}
      </Script>

      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <GlobalStyles theme={theme} />
          <ReactNotifications />
          <Layout>
            <motion.main>
              {isRouteLoading && (
                <Styled.LoadingContainer isLoading={isRouteLoading}>
                  <Styled.LoadingWrapper>
                    <LoadingDots />
                  </Styled.LoadingWrapper>
                </Styled.LoadingContainer>
              )}
              <Component {...pageProps} />
            </motion.main>
          </Layout>

          <ReactQueryDevtools initialIsOpen={false} />
        </ThemeProvider>
      </QueryClientProvider>
    </>
  );
}

export default GlobalStore;
